<script setup lang="ts">
    import KButton from "@/components/Button.vue";
    import { useStore } from "@/store";
    import SMSKallelser from "@/tabs/Operation/KallelserOchSms.vue";
    import { computed } from "vue";

    const store = useStore();

    const canOpenKallelser = computed(() => {
        return store.getters["ability/can"]({ action: "kallelse", subject: "anmalan" });
    });

    const onClick = () => {
        store.dispatch("tabs/openTab", { component: SMSKallelser });
    };
</script>

<template>
    <KButton variant="link" @click="onClick" :disabled="!canOpenKallelser"> Kallelser och sms </KButton>
</template>
